import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import styles from "./thank-you-slide.css";

import type { SlideViewMode } from "../slide/slide";

@customElement("bp-thank-you-slide")
export class ThankYouSlide extends LitElement {
  static styles = styles;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    return html`
      <div class="thank-you-slide ${this.viewMode}">
        <div class="content-container">
          <div class="content">
            <div class="title">Thank You</div>
            <div class="post-title">
              Classroom is free because of the generous support of people like
              you.
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-thank-you-slide": ThankYouSlide;
  }
}
